import styled from "styled-components";

import { ContentDiv } from "./CreditAuthStyles";

interface IOverlayPanelContainer {
  height?: string;
  width?: string;
  active?: any;
}
export const OverlayPanelContainer = styled.div<IOverlayPanelContainer>`
  background: white;
  border-radius: 0.8rem;
  box-shadow: 0rem 0.9rem 5rem 0rem rgba(0, 0, 0, 0.1);
  height: ${(props) => (props.height ? props.height : "31rem")};
  opacity: 0;
  overflow: hidden;
  position: absolute;
  right: 100vw;
  transition: opacity 0.2s;
  width: ${(props) => (props.width ? props.width : "31rem")};
  z-index: 1;

  ${(props) =>
    props.active
      ? `  
    opacity: 1;
    right: 0rem;
    top: 5.37rem;
  `
      : ""}

  .panel-children {
    height: 100%;
    padding: 1rem;
    width: 100%;
  }

  @media (max-width: 600px) {
    ${(props) =>
      props.active
        ? `
      left: -50vw;
      width: 85vw;
    `
        : ""}

    .panel-header {
      display: none;
    }

    ${ContentDiv} {
      grid-template-columns: 1fr;
    }
  }
`;

export const Container = styled.div`
  position: relative;
`;

interface IButtonPanelDiv {
  background?: string;
}
export const ButtonPanelDiv = styled.button<IButtonPanelDiv>`
  align-items: center;
  background: ${(props) =>
    props.background ? props.background : props.theme.colors.primaryBlue};
  border-color: transparent;
  border-radius: 1rem;
  cursor: pointer;
  display: flex;
  height: 3.4rem;
  justify-content: center;
  width: 3.4rem;

  img {
    height: 3.4rem;
    width: 3.4rem;
  }
`;
